const COLUMN_HEIGHT = 260;
const LABEL_ROOM = 24;
const STEP_LADDER = [1, 1.5, 2, 2.5, 5, 7.5, 10];

export const BREAKDOWN_COLUMN_HEIGHT = COLUMN_HEIGHT;

const niceStep = (value: number): number => {
  const magnitude = 10 ** Math.floor(Math.log10(Math.max(value, 1e-6)));
  return (STEP_LADDER.find((candidate) => candidate * magnitude >= value) ?? 10) * magnitude;
};

export type BreakdownScale = {
  ticks: number[];
  y: (value: number) => number;
};

// One step below zero is always reserved, even for an all-gains lens, so the columns
// never sit flush on the floor.
export const buildScale = (deltas: number[], netChange: number): BreakdownScale => {
  const highest = Math.max(0, netChange, ...deltas);
  const lowest = Math.min(0, netChange, ...deltas);
  const step = niceStep(Math.max((highest - lowest) / 4, 0.001));
  const top = Math.max(Math.ceil(highest / step) * step, step);
  const bottom = Math.min(Math.floor(lowest / step) * step, -step);

  const ticks: number[] = [];
  for (let tick = bottom; tick <= top + step / 100; tick += step) {
    ticks.push(Math.round(tick * 1000) / 1000);
  }

  const padTop = deltas.some((delta) => delta > 0) ? LABEL_ROOM : 6;
  const padBottom = deltas.some((delta) => delta < 0) ? LABEL_ROOM + 4 : 6;
  const plotHeight = Math.max(COLUMN_HEIGHT - padTop - padBottom, 1);

  return {
    ticks,
    y: (value: number) => padTop + (plotHeight * (top - value)) / (top - bottom || 1),
  };
};
